import NiceModal from '@ebay/nice-modal-react';
import { ActionIcon, Tooltip } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { IconQrcode } from '@tabler/icons-react';
import { AxiosError } from 'axios';

import { useConnectPage } from '../../../../api';
import { QrAuthModal } from '../Modals/QrAuthModal/QrAuthModal';

import { toasts } from '@/utils/toasts';

const TOAST_ID = 'tg-qr-connect';

type Props = {
  pageId: string;
  pageName: string;
};

export const QrConnectButton = ({ pageId, pageName }: Props) => {
  const connect = useConnectPage({
    config: {
      onMutate: () => toasts.loadingToast.loading(TOAST_ID, 'Запрос QR-входа…'),
      // The opened modal is the success feedback; only a failure needs a toast.
      onSuccess: () => notifications.hide(TOAST_ID),
      onError: (error) =>
        toasts.loadingToast.error(
          TOAST_ID,
          (error as AxiosError<{ error: string }>).response?.data?.error
        ),
    },
  });

  return (
    <Tooltip label="Connect via QR code">
      <ActionIcon
        aria-label="Connect via QR code"
        variant="filled"
        loading={connect.isLoading}
        onClick={() =>
          connect.mutate(
            { pageId, platform: 'telegram', authMethod: 'qr' },
            { onSuccess: () => NiceModal.show(QrAuthModal, { pageId, pageName }) }
          )
        }
        radius="md"
        style={{ alignSelf: 'flex-start' }}
      >
        <IconQrcode />
      </ActionIcon>
    </Tooltip>
  );
};
